import React, { useState } from 'react'
import { Container, FlexColumn, FlexRow } from 'components/common/Containers'
import HeroImage from './images/hero.svg'
import styles from './Subscribe.module.scss'
import { TagInput } from 'components/common/Input/TagInput'
import SubscribeButton from './components/SubscribeButton/SubscribeButton'
import { useGetUser } from 'hooks/useGetUser'

interface Props {
  trigger?: boolean
  tags: string[]
  setTags: React.Dispatch<React.SetStateAction<string[]>>
  interval: string
  setInterval: React.Dispatch<React.SetStateAction<string>>
  onSubscribe: () => void
  isLoading: boolean
}

const Subscribe: React.FC<Props> = ({
  trigger,
  tags,
  setTags,
  interval,
  setInterval,
  onSubscribe,
  isLoading,
}) => {
  const { data: user } = useGetUser()

  return (
    <Container>
      <section className={styles.section}>
        <FlexRow className={styles.row} justify="space-between">
          <FlexColumn className={styles.content} gap="20px" justify="center">
            <FlexColumn gap="10px">
              <h2 className={styles.title}>Subscribe to Alerts!</h2>

              <p>
                Subscribe for daily/weeky/monthly alerts of the keywords on your
                watch list
              </p>
            </FlexColumn>

            <TagInput
              trigger={trigger}
              wrapperClassName={styles.input}
              className={styles.input}
              tags={tags}
              onChange={setTags}
              placeholder="Type Keyword..."
            />

            <SubscribeButton
              interval={interval}
              setInterval={setInterval}
              email={user?.email}
              onSubmit={onSubscribe}
              isLoading={isLoading}
            />
          </FlexColumn>

          <div className={styles.imageWrapper}>
            <HeroImage />
          </div>
        </FlexRow>
      </section>
    </Container>
  )
}

export default Subscribe
